import { ColumnAction } from '@shared/interfaces/column-action.interface';

/**
 *
 * UiColumn will serve as a resuable class to define grid columns
 * 
 * */

export class UiColumn {

  field: string;
  title: string;
  sortable: boolean;
  filterable: boolean;
  type: "text" | "numeric" | "boolean" | "date";
  sortOrder: string;
  size: number;
  editor: "text" | "numeric" | "boolean" | "date";
  headerTemplate: string = "";
  cellTemplate: string = "";
  cellProperties: string = "";
  hidden: boolean;
  aggregate: "sum" | "average" | "count" | "min" | "max";
  format?: string;
  hasActions: boolean = false;
  actions: ColumnAction[];
  groupIndex?: number;
  convertDate: boolean = true;
  visibleIndex: number;
  filterFormat?: string;

  /// ? signifies an optional parameter 
  constructor();
  constructor(name: string, languageKey: string, width: number, filter?: boolean, type?: "text" | "numeric" | "boolean" | "date", sort?: boolean, sOrder?: string);
  constructor(...arr: any[]) {
    if (arr.length > 0) {
      this.field = arr[0];
      this.title = arr[1];
      this.size = arr[2];

      var filter: boolean = Boolean(arr[3]);
      this.filterable = filter ? filter : true;

      this.type = arr[4] ? arr[4] : "text";
    }

    this.hidden = false;
  }

  /**
    Filter Options:
      text (default) - Ui is a TextBox component
      numeric - Ui is a NumericTextBox component
      date - Ui is a DatePicker component
      boolean - Ui is a DropDownList component with (All), Is True, and Is False as selectable options
  */

}
